import { useQuery } from 'react-query';
import { queryKeys } from '../constants';
import api from 'api';
import { dateFormats } from 'utils/Dates';
import { format } from 'date-fns';
import { AppError } from 'utils/AppError';
import { RecurringDeductionsData } from '../types';
import { paiseAmountToRupee } from 'utils/Numbers';
import { filterOutFnfComponents } from 'components/SalaryComponents/utils';

type UseListDeductionsProps = {
  userId: string;
  onSuccess?: (response: RecurringDeductionsData[]) => void;
  isEnabled?: boolean;
};

const useListDeductions = ({ userId, isEnabled, onSuccess }: UseListDeductionsProps) => {
  const listDeductionsQuery = useQuery({
    queryKey: [queryKeys.FETCH_LIST_DEDUCTIONS],
    queryFn: () => {
      const formattedDate = format(new Date(), dateFormats.yearMonthDate);
      return api.salaryComponents.queries.listDeductions({
        userId,
        effectiveFrom: formattedDate,
        effectiveTo: formattedDate,
        payType: 'LIST_RECURRING_TYPE',
      });
    },
    cacheTime: 0,
    select: (response) => {
      if (response.payrollListDeductions.data.data.length === 0) {
        return [];
      }

      const deductions = response.payrollListDeductions.data.data;

      const filteredDeductions = filterOutFnfComponents(deductions);

      return filteredDeductions.map((item) => {
        return {
          id: item.id,
          componentId: item.componentDetails.id,
          componentName: item.componentDetails.settings.behaviour.displayBehaviour?.displayName,
          monthlyAmount: paiseAmountToRupee(item.amount),
        };
      }) as RecurringDeductionsData[];
    },
    enabled: isEnabled,
    onSuccess,
    onError: (error: AppError) => {},
  });

  return listDeductionsQuery;
};

export default useListDeductions;
